export const LOAD_PAYMENTS_REQUEST = 'PaymentsPage/LOAD_PAYMENTS_REQUEST';
export const LOAD_PAYMENTS_SUCCESS = 'PaymentsPage/LOAD_PAYMENTS_SUCCESS';
export const LOAD_PAYMENTS_FAILURE = 'PaymentsPage/LOAD_PAYMENTS_FAILURE';
export const CREATE_PAYMENTS_REQUEST = 'PaymentsPage/CREATE_PAYMENTS_REQUEST';
export const CREATE_PAYMENTS_SUCCESS = 'PaymentsPage/CREATE_PAYMENTS_SUCCESS';
export const CREATE_PAYMENTS_FAILURE = 'PaymentsPage/CREATE_PAYMENTS_FAILURE';
